export default __webpack_public_path__ + "static/ruth-breindel-66f6efbc912cb87362053fea4fca5ab0.webp";